export const Funcionalidades = {
  oitiva: {
    cadastrar: 'mac-func-oitiva_cadastrar',
    consultar: 'mac-func-oitiva_consultar',
    editar: 'mac-func-oitiva_alterar',
    visualizar: 'mac-func-oitiva_finalizar',
    finalizar: 'mac-func-oitiva_finalizar',
    excluir: 'mac-func-oitiva_excluir',
    resumoVisualizar: 'mac-func-oitiva_resumo_visualizar',
    rascunhoVisualizar: 'mac-func-oitiva_rascunho_visualizar',
    download: 'mac-func-oitiva_download',
  },
  fichaAdolescente: {
    consultar: 'mac-func-ficha_adolescente_consultar',
    editar: 'mac-func-ficha_adolescente_editar',
    visualizar: 'mac-func-ficha_adolescente_visualizar',
    imprimir: 'mac-func-ficha_adolescente_imprimir',
    exportar: 'mac-func-ficha_adolescente_exportar',
  },
  integraPolicial: {
    consultar: 'mac-func-integra_policial_consultar',
    visualizar: 'mac-func-integra_policial_visualizar',
    editar: 'mac-func-integra_policial_editar',
    adolescente: {
      adicionar: 'mac-func-integra_policial_adolescente_adicionar',
      excluir: 'mac-func-integra_policial_adolescente_excluir',
      informarStatus: 'mac-func-integra_policial_adolescente_informar_status',
      iniciarOitiva: 'mac-func-integra_policial_adolescente_iniciar_oitiva',
    },
  },
  relatorio: {
    auditoria: {
      fichaAdolescente: {
        consultar: 'mac-func-relatorio_ficha_adolescente_consultar',
      },
    },
  },
  notificacoes: {
    consultar: 'mac-func-notificacoes_consultar',
    visualizar: 'mac-func-notificacoes_visualizar',
    excluir: 'mac-func-notificacoes_excluir',
  },
  creas: {
    consultar: 'mac-func-creas_consultar',
    visualizar: 'mac-func-creas_visualizar',
    excluir: 'mac-func-creas_excluir',
    cadastrar: 'mac-func-creas_cadastrar',
    editar: 'mac-func-creas_editar',
  },
  meioAberto: {
    consultar: 'mac-func-meio-aberto_consultar',
    visualizar: 'mac-func-meio-aberto_visualizar',
    excluir: 'mac-func-meio-aberto_excluir',
    cadastrar: 'mac-func-meio-aberto_cadastrar',
    editar: 'mac-func-meio-aberto_editar',
    relatorio: {
      gerar: 'mac-func-meio-aberto_relatorio_gerar',
    },
  },
}

export const hearingFunctionalities = {
  cadastrar: 'mac-func-oitiva_cadastrar',
  consultar: 'mac-func-oitiva_consultar',
  editar: 'mac-func-oitiva_alterar',
  visualizar: 'mac-func-oitiva_finalizar',
  finalizar: 'mac-func-oitiva_finalizar',
  excluir: 'mac-func-oitiva_excluir',
  resumoVisualizar: 'mac-func-oitiva_resumo_visualizar',
  rascunhoVisualizar: 'mac-func-oitiva_rascunho_visualizar',
  download: 'mac-func-oitiva_download',
}

export const teenagerRecordFunctionalities = {
  consultar: 'mac-func-ficha_adolescente_consultar',
  visualizar: 'mac-func-ficha_adolescente_visualizar',
  imprimir: 'mac-func-ficha_adolescente_imprimir',
  exportar: 'mac-func-ficha_adolescente_exportar',
  editar: 'mac-func-ficha_adolescente_editar',
}
